<template>
  <div
    :class="{ 'search-filters': true, 'mobile-filter': isMobile }"
    v-if="selection && selection.length > 0"
  >
    <div :class="{ 'search-filters-header': true, 'list-closed': isMobile && !showList }">
      <h3>Filters</h3>
      <div
        class="search-filters-header-icon"
        v-on:click="toggleShowList()"
        v-if="isMobile"
      >
        <i class="fas fa-bars fa-fw"></i>
      </div>
    </div>

    <div class="search-filters-container" v-if="!isMobile || showList">
      <div class="search-filters-tags">
        <div
          class="search-filters-tag"
          v-on:click="deleteFilter(item)"
          v-for="item of selected"
        >
          <i class="fas fa-times"></i>
          <span>{{ item.label }}</span>
        </div>
      </div>
      <div class="search-filter" v-for="filter of selection">
        <h4>{{ filter.label }}</h4>
        <div class="search-filter-items">
          <div class="search-filter-item" v-for="item of filter.values">
            <div
              class="search-filter-item-name"
              v-on:click="selectFilter(item)"
            >
              {{ item.label }}
            </div>
            <div
              class="search-filter-item-count"
              v-on:click="selectFilter(item)"
            >
              {{ item.count }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SearchFilter",

  data() {
    return {
      showList: false,
    };
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      filters: (state) => state.search.filters,
      selection: (state) => state.search.filters.selection,
      selected: (state) => state.search.filters.selected,
    }),
    selectedFilters() {
      return Object.values(this.selected);
    },
  },

  methods: {
    ...mapMutations(["addFilter", "removeFilter"]),
    selectFilter(item) {
      this.addFilter(item);
    },
    deleteFilter(item) {
      this.removeFilter(item);
    },
    toggleShowList() {
      this.showList = !this.showList;
    },
  },
};
</script>

<style scoped>
.search-filters {
  min-width: 210px;
  padding: 12px 10px;
  border: 1px solid var(--wwfTransparentBlack015);
}

.search-filters-container {
  flex-wrap: wrap;
}

.search-filters h3 {
  margin-left: 10px;
  margin-right: 10px;
}

.search-filter {
  margin-bottom: 16px;
}

.search-filter:last-child {
  margin-bottom: 0px;
}

.search-filter h4 {
  margin-bottom: 8px;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 1;
}

.search-filters-tags {
  flex-basis: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.search-filters-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  margin-left: 6px;
  height: 20px;
  border-radius: 10px;
  color: var(--wwfWhite);
  font-size: 12px;
  background-color: var(--wwfOrange);
  cursor: pointer;
}

.search-filters-tag span {
  margin-left: 4px;
}

.search-filter-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 10px;
  cursor: pointer;
}

.search-filter-item:hover {
  background-color: var(--wwfGreyE4);
}

.search-filter-item-name {
  flex: 1;
  margin-right: 8px;
}

.search-filter-item-count {
  padding: 2px 4px;
  font-size: 12px;
  background-color: var(--wwfGreyC8);
  border-radius: 4px;
}

/* MOBILE STYLE */

.search-filters-header {
  display: flex;
  justify-content: space-between;
}

.search-filters-header.list-closed h3 {
  margin-bottom: 0;
  padding-bottom: 12px;
}

.search-filters-header .search-filters-header-icon {
  margin: 10px;
  font-size: 24px;
  cursor: pointer;
}

.mobile-filter .search-filters-container {
  display: flex;
}

.mobile-filter .search-filter {
  flex: 1;
  max-width: 200px;
}

</style>


// WEBPACK FOOTER //
// searchFilter.vue?7f88e2bd